import {HttpConsts} from '@multipass-common-dto';
import {FetchOptions, FetchResults, FetchService} from '@multipass-system';
import {Logger} from 'esp-js';

const _log = Logger.create('FetchService');

export class FetchServiceImpl implements FetchService {
    async fetch<T>(options: FetchOptions): Promise<FetchResults<T>> {
        const headers = new Headers();
        if (options.headers) {
            for (const header of options.headers) {
                headers.append(header[0], header[1]);
            }
        }
        headers.append('Content-Type', 'application/json');
        headers.append(HttpConsts.WorkflowIdHeaderName, options.workflowId);
        const csrfToken = this.#getCookie(HttpConsts.CrsfToken);
        if (csrfToken) {
            headers.append(HttpConsts.CrsfTokenHeaderName, csrfToken);
        }
        _log.debug(`Fetching ${options.url}`);
        const response = await fetch(options.url, {
            method: options.method,
            headers,
            credentials: 'include',
            body: options.body && JSON.stringify(options.body),
        });
        if (response.ok) {
            const text = await response.text();
            let payload: any = text;
            if (payload) {
                try {
                    payload = JSON.parse(text);
                } catch (e: any) {
                    _log.warn(`Error parsing body ${text} to JSON will propagate as text`);
                }
            }
            return {
                ok: response.ok,
                payload,
                status: response.status,
                statusText: response.statusText,
                workflowId: options.workflowId,
            } as FetchResults<T>;
        } else {
            return {
                ok: response.ok,
                error: `${response.status} - ${response.statusText}`,
                status: response.status,
                statusText: response.statusText,
                workflowId: options.workflowId,
            } as FetchResults<T>;
        }
    }

    #getCookie = (name: string) => {
        const match = document.cookie.match(RegExp(`${name}=.[^;]*`));
        if (match) {
            const cookie = match[0];
            return cookie.split('=')[1];
        }
        return null;
    };
}
